import "core-js/es/object"
import "core-js/es/array"
import "core-js/es/number"
import "core-js/es/date"
import "core-js/es/promise"
import "core-js/es/map"
import "core-js/es/set"
import "core-js/es/function/name"
import "core-js/es/function/bind"
import "core-js/es/string/includes"
import "core-js/es/string/starts-with"
import "core-js/es/string/ends-with"
import "core-js/es/string/trim"
import "core-js/es/math/trunc"
import "core-js/web/dom-collections"

if (!window.document.baseURI) {
    (window.document as any).baseURI = window.document.querySelector("base").href;
}

if (window.localStorage) {
    try {
        localStorage.setItem("_", "");
        localStorage.removeItem("_");
    } catch (ex) {
        console.debug("Local Storage is unavailable in this browser. Applying shim to globally suppress errors.")
        localStorage.setItem = () => {};
        localStorage.getItem = () => null;
        localStorage.clear = () => {};
        localStorage.key = () => null;
    }
}

if (window.sessionStorage) {
    try {
        sessionStorage.setItem("_", "");
        sessionStorage.removeItem("_");
    } catch (ex) {
        console.debug("Session Storage is unavailable in this browser. Applying shim to globally suppress errors.")
        sessionStorage.setItem = () => {};
        sessionStorage.getItem = () => null;
        sessionStorage.clear = () => {};
        sessionStorage.key = () => null;
    }
}
